import React from 'react';
import ApplicationsList from '../../components/student/ApplicationsList/ApplicationsList';

const MyApplications = () => {
  return (
    <div>
      <ApplicationsList />
    </div>
  );
};

export default MyApplications;